import { render, staticRenderFns } from "./pay-2.vue?vue&type=template&id=f49cc288&scoped=true&"
import script from "./pay-2.vue?vue&type=script&lang=js&"
export * from "./pay-2.vue?vue&type=script&lang=js&"
import style0 from "./pay-2.vue?vue&type=style&index=0&id=f49cc288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49cc288",
  null
  
)

export default component.exports